import Config from '../configs/appConfig';



const isLocal = document.location.hostname === 'localhost';
const isMcontent = document.location.hostname === 'panel.mc.hccmp.com';
const isMqa = document.location.hostname === 'panel.mqa.hccmp.com';
// const isDev = Config.VITE_APP_ENVIRONMENT === 'develop' || isLocal;
// const isQa = Config.VITE_APP_ENVIRONMENT === 'staging' || isLocal;
const isProd = Config.VITE_APP_ENVIRONMENT === 'production';


export const IS_LOCAL_ENV = isLocal;
export const IS_MCONTENT_ENV = isMcontent;
export const IS_MQA_ENV = isMqa;
export const FEATURE_SHOW_TEST_MODE = !isProd;
export const FEATURE_SHOW_OLD_NEWS = isLocal;
export const FEATURE_SHOW_UTC_FROM_TO = false;
